<template lang="pug">
.container
  .header
    div(style="flex: 1 0; font-size: 1.2rem") 
      div Lotto
      div(style="color: black; font-size: 0.8rem") {{ qualityShort }}
    button3d(style="margin: 0 6px 0 0")
      icon(name="print", @click="print()")
    button3d(style="margin: 0 6px 0 0", :class="{ selected: mode == 'chart' }")
      icon(name="chart", @click="switchMode('chart')")
    button3d(:class="{ selected: mode == 'list' }")
      icon(name="tasks", @click="switchMode('list')")
  .header(style="gap: 0.5rem; justify-content:flex-start;")
    div(style="display: flex; align-items: center; justify-content:flex-start; flex: 0 0 auto")
      button3d(@click="prevSet()")
        icon.small(name="chevronLeft")
      div(
        v-if="currentSet",
        style="flex: 2 0; color: black; margin: 0 4vw; font-size: 0.8rem"
      )
        div {{ currentSet.name }}
        div {{ currentSet.comment }}
      button3d(@click="nextSet()")
        icon.small(name="chevronRight")
    //- div(style="display: flex; align-items: center; flex: 0 0 auto")
    //-   button3d(@click="prev()")
    //-     icon.small(name="chevronLeft")
    //-   div(
    //-     v-if="currentSet && ticket",
    //-     style="width: 4rem; color: black; margin: 0 0.1rem; font-size: 0.8"
    //-   ) {{ ticket.index }} # {{ currentSet.tickets.length }}
    //-   button3d(@click="next()")
    //-     icon.small(name="chevronRight")
  .lotto(v-if="ticket")
    .grid(
      ref="swipe",
      :style="swipeStyle",
      @touchstart.passive="onTouchStart",
      @touchmove.prevent="onTouchMove",
      @touchend="onTouchEnd"
    )
      div(
        style="font-size: 1.2rem; color: black; align-self: flex-start; margin: 0 1rem"
      ) {{ ticket.index }} # {{ currentSet.tickets.length }} - Losnummer: {{ ticket.number }}
      .fields
        lotto-grid(
          v-for="(r, rix) in ticket.fields",
          :checked="r",
          :sz="ticket.number",
          :draw="draw",
          :id="rix + 1",
          :cfg="{ grid: 1, small: 1, micro: 1 }",
          @click="zoomed = r"
        )
        .zoomPanel(v-if="zoomed", @click="zoomed = null")
          lotto-grid(
            :checked="zoomed",
            :sz="ticket.number",
            :draw="draw",
            :cfg="{ grid: 1 }"
          )
    .win
      //div(style="font-size:0.8rem;color:#048;") {{ quality }}, 
      .winGrid
        template
          .cell(@click="showDetails = 1 - showDetails", style="display: flex") 
            icon.tiny(name="chevronDown", v-if="!showDetails")
            icon.tiny(name="chevronUp", v-if="showDetails")
            span(style="flex: 1 0") Gesamt im Set
          .cell(v-if="!waiting", style="grid-column: span 3") {{ totalWin.toFixed(2) }} € - {{ totalPrice.toFixed(2) }} € = {{ totalNetto.toFixed(2) }} €
          .cell(v-if="waiting", style="grid-column: span 3; overflow: auto") {{ allHits && allHits.map((h) => `${h.hits}×${h.k}(${h.win.toFixed(2)})`).join(", ") }}
        template(v-if="showDetails", v-for="w in check77(ticket, draw)")
          .cell {{ w.field }}
          .cell(v-if="!w.wait") {{ w.winningClassShortName }}
          .cell(v-if="!w.wait") {{ w.numberOfWinners }}
          .cell(v-if="!w.wait") {{ (w.odds || w.jackpot || 0).toFixed(2) }} €
          .cell(v-if="w.wait", style="grid-column: span 3") wird ermittelt
        template(v-if="showDetails", v-for="w in checks6(ticket, draw)")
          .cell {{ w.field }}
          .cell(v-if="!w.wait") {{ w.winningClassShortName }}
          .cell(v-if="!w.wait") {{ w.numberOfWinners }}
          .cell(v-if="!w.wait") {{ (w.odds || w.jackpot || 0).toFixed(2) }} €
          .cell(v-if="w.wait", style="grid-column: span 3") wird ermittelt
        template(v-if="showDetails", v-for="w in won")
          .cell {{ w.field }}
          .cell {{ w.winningClassShortName }}
          .cell {{ w.numberOfWinners }}
          .cell {{ (w.odds || w.jackpot || 0).toFixed(2) }} €
        template(v-if="showDetails && !won.length && hits.length")
          .cell Treffer
          .cell(style="grid-column: span 3")
            span {{ hits.map((h) => `${h.hits}×${h.k}(${h.win.toFixed(2)})`).join(", ") }}
    .checked(style="background: #cef")
      div(style="display: flex; margin: 0.5rem 0")
        icon.button.small(name="chevronLeft", @click="nextDraw()")
        select(v-model="selectedDate", @change="selectDate(selectedDate)")
          option(v-for="d in dates", :value="d") {{ new Date(1 * d).toLocaleDateString("de-DE", dateOpts) }}
        icon.button.small(name="chevronRight", @click="prevDraw()")
        div(
          style="font-size: 0.8rem;margin-left: 1rem;"
        )
          div(v-if="draw && draw.game77") S77: {{ draw.game77.numbers }}
          div(v-if="draw && draw.super6") S6: {{ draw.super6.numbers }}
      div(style="display: flex; padding: 0.25rem 0; align-items: center")
        div(v-for="d in draw.drawNumbersCollection")
          .ball {{ d }}
          .shadow
        div(
          style="margin: 0 0.2rem; width: 2px; align-self: stretch; background-color: gray"
        )
        div
          .ball {{ draw.superNumber }}
          .shadow

    //- div(style="color:black;font:8pt arial;") DATA: {{chartData}}
  .list(v-if="mode == 'list'")
    template(v-for="(d, ix) in reversed")
      div(:class="{ old: d.date < dateStart.date }", @click="setStartDate(d)") {{ new Date(d.date).toLocaleDateString() }}
      div(:class="{ neg: d.netto < 0, old: d.date < dateStart.date }") {{ d.netto.toLocaleString("de-DE", { minimumFractionDigits: 2 }) }}
      div(
        :class="{ neg: d.cumulative - dateStart.cumulative < 0, old: d.date < dateStart.date }"
      ) {{ d.date < dateStart.date ? "" : (d.cumulative - dateStart.cumulative).toLocaleString("de-DE", { minimumFractionDigits: 2 }) }}
  LottoWinChart(v-if="mode == 'chart'", :wins="chartData") 
  .print
    .ticketGroup(v-for="group in groupedTickets")
      div(style="display: flex; justify-content: space-around")
        div(style="font-size: 1rem; color: black") {{ currentSet.name }}
        div(style="flex: 1 0")
        div(style="font-size: 1rem; color: black") {{ currentSet.comment }}
      .ticket(v-for="t in group")
        lotto-grid(v-for="f in t.fields", :checked="f", :cfg="{ grid: 1 }")
    div(style="height: 8rem")
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Icon from "@/components/Icon.vue";
import Button3d from "@/components/Button3d.vue";
import LottoGrid from "@/components/LottoGrid.vue";
import LottoWinChart from "./LottoWinChart.vue";

export default {
  components: { Icon, Button3d, LottoGrid, LottoWinChart },
  data() {
    return {
      touchStartX: 0,
      swipeX: 0,
      swiping: false,
      showDetails: 0,
      dateOpts: {
        weekday: "short",
        year: "numeric",
        month: "numeric",
        day: "numeric",
      },
      wins: ["6+", "6", "5+", "5", "4+", "4", "3+", "3", "2+"],
      averages: {
        "6+": {
          total: 1091947281.6,
          count: 84,
          max: 48580715.3,
          min: 1704918.8,
          average: 12999372.399999999,
          name: "6 + SZ",
        },
        6: {
          total: 536226557.5,
          count: 365,
          max: 22500000,
          min: 171461.2,
          average: 1469113.8561643835,
          name: "6",
        },
        "5+": {
          total: 7096466.6,
          count: 480,
          max: 184107.1,
          min: 3228.1,
          average: 14784.305416666668,
          name: "5 + SZ",
        },
        5: {
          total: 2124628.5,
          count: 480,
          max: 9145.5,
          min: 1069.5,
          average: 4426.309375000001,
          name: "5",
        },
        "4+": {
          total: 95323.1,
          count: 480,
          max: 378.9,
          min: 66.7,
          average: 198.5897916666668,
          name: "4 + SZ",
        },
        4: {
          total: 24801.0,
          count: 480,
          max: 84.4,
          min: 23,
          average: 51.66875000000002,
          name: "4",
        },
        "3+": {
          total: 10361.5,
          count: 480,
          max: 36.9,
          min: 9.6,
          average: 21.586458333333344,
          name: "3 + SZ",
        },
        3: {
          total: 5350.0,
          count: 480,
          max: 15.7,
          min: 6.6,
          average: 11.145833333333336,
          name: "3",
        },
        "2+": {
          total: 2880,
          count: 480,
          max: 6,
          min: 6,
          average: 6,
          name: "2 + SZ",
        },
      },
      selectedDate: 0,
      sum: 0,
      max: 0,
      dates: [],
      freq: {},
      currentSet: null,
      totalWin: 0,
      totalPrice: 0,
      totalNetto: 0,
      ticket: null,
      allItems: [],
      draw: {},
      zoomed: false,
      chartData: [],
      mode: null,
      printing: true,
      dateStart: { date: 0, netto: 0, cumulative: 0 },
    };
  },
  computed: {
    ...mapGetters({
      items: "lotto/items",
      sets: "lotto/sets",
    }),
    swipeStyle() {
      return {
        transform: `translateX(${this.swipeX}px)`,
        transition: this.swiping ? "none" : "transform 0.25s ease-out",
        opacity: this.swiping ? 0.95 : 1,
      };
    },
    reversed() {
      return this.chartData.slice().reverse();
    },
    qualityShort() {
      const q = this.currentSet?.quality;
      if (!q) return "";
      return `${q.stdDev.toFixed(2)}, ${q.overlapPenalty}`;
    },
    quality() {
      const q = this.currentSet.quality;
      if (!q) return "";
      return `Quality: ${q.quality.toFixed(2)}, ${q.diversityScore.toFixed(
        2
      )}, ${q.spreadScore.toFixed(2)}, ${q.overlapScore.toFixed(2)}
(${q.stdDev.toFixed(2)}, ${q.overlapPenalty})`;
    },
    waiting() {
      return !this.draw.oddsCollection;
    },
    groupedTickets() {
      const tickets = this.currentSet?.tickets || [];
      const groups = [];
      for (let i = 0; i < tickets.length; i += 4) {
        groups.push(tickets.slice(i, i + 4));
      }
      return groups;
    },
    allHits() {
      const h = {};
      const ts = this.ticket;
      this.currentSet.tickets.forEach((t) => {
        this.ticket = t;
        const x = this.hits;
        x.forEach((v) => {
          h[v.k] = h[v.k] || { hits: 0, win: 0 };
          h[v.k].hits += v.hits;
          h[v.k].win += v.win;
        });
        this.ticket = ts;
      });
      console.log("HITS:", h);
      return Object.keys(h).map((k) => ({ k, ...h[k] }));
    },
    hits() {
      if (!this.ticket) return [];
      const h = {};
      this.ticket.fields.forEach((f, ix) => {
        const nums = (this.draw && this.draw.drawNumbersCollection) || [];
        let n = 0;
        f.forEach((i) => {
          if (nums.includes(i)) n++;
        });
        const hasSN =
          this.draw && this.draw.superNumber == this.ticket.number % 10;
        const hit = n > 2 || (n > 1 && hasSN);
        if (hit) {
          const display = `${n}${hasSN ? "+" : ""}`;
          h[display] = h[display] || { hits: 0, win: 0 };
          h[display].hits++;
          h[display].win += this.averages[display].average;
        }
      });
      const hits = Object.keys(h).map((k) => ({ k, ...h[k] }));
      console.log("titcket hits:", hits);
      return hits;
    },
    won() {
      const wins = [];
      if (!this.ticket) return wins;

      this.ticket.fields.forEach((f, ix) => {
        const w = this.matching(this.ticket, f);
        const wc = this.wins.indexOf("" + w);
        if (wc >= 0) {
          if (!this.draw.oddsCollection) return null;
          const o = this.draw.oddsCollection.find(
            (x) => x.winningClass == wc + 1
          );
          if (o) wins.push({ ...o, field: ix + 1 });
        }
      });
      return wins;
    },
  },
  methods: {
    ...mapActions({
      load: "lotto/load",
      loadTickets: "lotto/loadSets",
    }),
    onTouchStart(e) {
      this.touchStartX = e.changedTouches[0].clientX;
      this.swiping = true;
    },

    onTouchMove(e) {
      const x = e.changedTouches[0].clientX;
      const dx = x - this.touchStartX;

      // gedämpfte Bewegung (klassischer Trick)
      this.swipeX = dx * 0.35;
    },

    onTouchEnd(e) {
      const dx = e.changedTouches[0].clientX - this.touchStartX;
      const threshold = 30;

      this.swiping = false;

      if (Math.abs(dx) > threshold) {
        if (dx < 0) {
          this.next();
        } else {
          this.prev();
        }
      }

      // immer sauber zurücksetzen
      this.swipeX = 0;
    },
    print() {
      window.print();
    },
    showField(f) {
      console.log(f);
      this.zoomed = f;
    },
    switchMode(m) {
      if (this.mode == m) {
        this.mode = null;
        return;
      }

      this.mode = m;
      this.getChartData();
    },
    setStartDate(d) {
      this.dateStart = { ...d, cumulative: d.cumulative - d.netto };
    },
    getChartData() {
      const wins = [];
      let price = this.currentSet.tickets.length * (0.5 + 1.25 + 2.5);
      let sum = 0;
      this.currentSet.tickets.forEach((t) => (price += t.fields.length * 1.2));
      const sortedDates = [...this.dates].sort(); //(a,b) => new Date(b).getTime() - new Date(a).getTime());
      sortedDates.forEach((d) => {
        this.getDrawing(d);
        let brutto = 0;
        this.currentSet.tickets.forEach((t, tix) => {
          if (this.draw.oddsCollection) {
            t.fields.forEach((f, fix) => {
              const w = this.matching(t, f);
              const wc = this.wins.indexOf("" + w);
              if (wc >= 0) {
                const o = this.draw.oddsCollection.find(
                  (x) => x.winningClass == wc + 1
                );
                if (o) {
                  brutto += o.odds || o.jackpot || 0;
                }
              }
            });
            const w77 = this.check77(t, this.draw);
            w77.forEach((t) => {
              brutto += t.odds || t.jackpot || 0;
            });
            const ws6 = this.checks6(t, this.draw);
            ws6.forEach((t) => {
              brutto += t.odds || t.jackpot || 0;
            });
          }
        });
        const netto = brutto - price;
        sum += netto;
        wins.push({ date: d, drawDate: new Date(d), netto, cumulative: sum });
      });
      if (this.dateStart.date) {
        this.setStartDate(wins.find((w) => w.date == this.dateStart.date));
        // console.log(wins.filter((x,ix) => ix<10), this.dateStart);
      }
      this.chartData = wins; //.filter((d,ix) => ix < 200);
    },
    getTotalWin() {
      this.totalPrice = this.currentSet.tickets.length * (0.5 + 1.25 + 2.5);
      this.currentSet.tickets.forEach(
        (t) => (this.totalPrice += t.fields.length * 1.2)
      );
      this.totalWin = 0;
      if (!this.draw.oddsCollection) return;

      this.currentSet.tickets.forEach((t, tix) => {
        t.fields.forEach((f, fix) => {
          const w = this.matching(t, f);
          const wc = this.wins.indexOf("" + w);
          if (wc >= 0) {
            const o = this.draw.oddsCollection.find(
              (x) => x.winningClass == wc + 1
            );
            if (o) {
              this.totalWin += o.odds || o.jackpot;
            }
          }
        });
        const w77 = this.check77(t, this.draw);
        w77.forEach((t) => {
          this.totalWin += t.odds || t.jackpot;
        });
        const ws6 = this.checks6(t, this.draw);
        ws6.forEach((t) => {
          this.totalWin += t.odds || t.jackpot;
        });
      });
      this.totalNetto = this.totalWin - this.totalPrice;
    },
    prevSet() {
      if (this.currentSet) {
        let ix = this.sets.findIndex((s) => s == this.currentSet);
        if (ix > 0) ix--;
        else ix = ix = this.sets.length - 1;
        this.selectSet(this.sets[ix]);
        if (this.mode) this.getChartData();
        // this.getChartData();
      }
    },
    nextSet() {
      if (this.currentSet) {
        let ix = this.sets.findIndex((s) => s == this.currentSet);
        if (ix >= this.sets.length - 1) ix = 0;
        else ix++;
        this.selectSet(this.sets[ix]);
        if (this.mode) this.getChartData();
        // this.getChartData();
      }
    },
    prev() {
      if (this.currentSet && this.ticket) {
        let ix = this.currentSet.tickets.findIndex(
          (t) => t.number == this.ticket.number
        );
        if (ix > 0) ix--;
        else ix = this.currentSet.tickets.length - 1;
        this.ticket = { ...this.currentSet.tickets[ix], index: ix + 1 };
      }
    },
    next() {
      if (this.currentSet && this.ticket) {
        let ix = this.currentSet.tickets.findIndex(
          (t) => t.number == this.ticket.number
        );
        if (ix < this.currentSet.tickets.length - 1) ix++;
        else ix = 0;
        this.ticket = { ...this.currentSet.tickets[ix], index: ix + 1 };
      }
    },

    selectSet(s) {
      this.currentSet = s;
      this.ticket = { ...this.currentSet.tickets[0], index: 1 };
      this.getTotalWin();
    },
    matching(ticket, checked) {
      let n = 0;
      if (!checked) return "";
      const nums = this.draw.drawNumbersCollection || [];

      checked.forEach((i) => {
        if (nums.includes(i)) n++;
      });
      const sz = ticket.number % 10;
      if (this.draw && this.draw.superNumber == sz) n += "+";
      return "" + n;
    },
    simulation() {
      this.$router.push({ name: "lottoSim" });
    },
    prevDraw() {
      const f = this.dates.findIndex((x) => x == this.selectedDate) + 1;
      if (f >= this.dates.length) f = 0;
      this.selectDate(this.dates[f]);
    },
    nextDraw() {
      const f = this.dates.findIndex((x) => x == this.selectedDate) - 1;
      if (f < 0) f = this.dates.length - 1;
      this.selectDate(this.dates[f]);
    },
    matchFromEnd(str1, str2) {
      let matchLength = 0;
      let i = str1.length - 1;
      let j = str2.length - 1;

      // Iteriere von hinten durch beide Strings
      while (i >= 0 && j >= 0 && str1[i] == str2[j]) {
        matchLength++;
        i--;
        j--;
      }

      return matchLength;
    },
    check77(ticket, draw) {
      if (!draw || !draw.game77) return [];
      const s77 = draw.game77.numbers;
      const m = this.matchFromEnd(s77, ticket.number + "");
      if (m < 1) return [];
      const name = draw.game77.name;
      if (!draw.game77.oddsCollection)
        return [
          {
            field: name,
            wait: 1,
          },
        ];
      const w = [{ ...draw.game77.oddsCollection[7 - m], field: name }];
      return w;
    },
    checks6(ticket, draw) {
      if (!draw || !draw.super6) return [];
      const s6 = draw.super6.numbers;
      const m = this.matchFromEnd(s6, ticket.number + "");
      if (m < 1) return [];
      const name = draw.super6.name;
      if (!draw.super6.oddsCollection)
        return [
          {
            field: name,
            wait: 1,
          },
        ];
      const w = [{ ...draw.super6.oddsCollection[6 - m], field: name }];
      return w;
    },
    selectDate(d) {
      this.selectedDate = d;
      this.getDrawing(d);
      let ix = this.sets.findIndex((s) => s == this.currentSet);
      if (ix < 0) ix = 0;
      this.selectSet(this.sets[ix]);
      return this.won;
    },
    color(n) {
      const c = ["", "", "#ccc", "#c86", "#864", "#642", "#420"];
      return c[n];
    },
    print() {
      window.print();
    },
    barwidth(n) {
      return (200 * n) / this.max + "px";
    },
    check(sel) {
      const found = [];
      this.items.forEach((t) => {
        const a = t.oddsCollection.filter((value) => sel.nums.includes(value));
        if (a.length > 2) {
          found.push({ ...t, a });
        }
      });
      found.sort((a, b) => {
        return a.drawDate - b.drawDate;
      });
      this.checked = found;
    },
    async getDrawing(date) {
      this.draw = this.items.find((x) => x.drawDate == date);
    },
  },
  async mounted() {
    console.log("lotto mounted.1");
    this.ticket = null;
    await this.loadTickets();
    console.log("lotto mounted.2");
    await this.load();
    console.log("lotto mounted.3");
    this.dates = this.items.map((x) => x.drawDate);
    this.selectDate(this.dates[0]);
    this.currentSet = this.sets[0];
    this.ticket = { ...this.currentSet.tickets[0], index: 1 };
    console.log("lotto mounted.4");
    // this.getChartData();
  },
};
</script>

<style lang="less" scoped>
.container {
  font-size: 1rem;
  overflow: auto;
  flex: 1 0;
  display: flex;
  flex-flow: column;
}
.lotto {
  display: flex;
  flex: 1 0;
  justify-items: flex-start;
  align-self: center;
  overflow: auto;
  touch-action: pan-y;
}
.grid {
  flex: 1 0;
  overflow: auto;
  display: grid;
  flex-flow: column;
  background-color: #e8f0f8;
  padding: 0.25rem 0;
  justify-items: center;
}
.fields {
  flex: 1 0;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-content: flex-start;
  position: relative;
}
.freq {
  padding: 0 4vh;
  display: flex;
  flex-flow: column;
  margin: 0 4vh;
  flex: 0 0 auto;
  overflow: auto;
  font-size: 1.4vh;
  color: black;
  align-self: stretch;
  align-items: flex-start;
}
.bar {
  text-align: left;
  margin: 2px 0;
  padding: 4px 0;
  background-color: #88cc88;
  flex: 0 0 auto;
}
.checked {
  flex: 0 0 auto;
  align-self: stretch;
  display: flex;
  flex-flow: column;
  overflow: auto;
  font-size: 1.8vh;
  color: black;
  overflow: auto;
  padding: 1vw;
  margin: 0 0.2rem;
  overflow: hidden;
  border: 1px solid gray;
}
.ball {
  font-size: 3rem;
  height: 5rem;
  width: 5rem;
  line-height: 5rem;
  border-radius: 5rem;
  margin: 0 0.5rem;
  background: radial-gradient(
    circle at 30% 30%,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 20%,
    rgba(80, 80, 80, 1) 70%,
    rgba(80, 80, 80, 1) 100%
  );
  z-index: 1;
}
.shadow {
  z-index: 0;
  margin-left: 0.4rem;
  margin-top: -8%;
  background: radial-gradient(#444f, #fff0 70%);
  height: 0.5rem;
  width: 5rem;
}
.win {
  flex: 0 0 auto;
  display: flex;
  flex-flow: column;
  background-color: #efe;
  padding: 0.2rem;
  margin: 0.2rem 0;
  align-self: stretch;
}
.zoomPanel {
  position: absolute;
  left: 4px;
  top: 4px;
  right: 4px;
  bottom: 4px;
  border: 1px solid gray;
  background-color: #eee;
}
.list {
  position: absolute;
  display: grid;
  grid-template-columns: 2fr 3fr 3fr;
  justify-items: stretch;
  text-align: right;
  overflow: auto;
  left: 0;
  top: 11.5rem;
  right: 0;
  bottom: 0;
  padding: 0.5rem;
  font-size: 1rem;
  color: black;
  background: #fff;
}
.neg {
  color: red;
}
.list > div {
  padding: 0.1rem 0.5rem;
}

.list > div:nth-child(6n + 4),
.list > div:nth-child(6n + 5),
.list > div:nth-child(6n + 6),
.odd {
  background: #ded;
}

.old {
  background-color: #ddd;
  color: gray;
}
@media screen and (orientation: portrait) {
  .header {
    font-size: 1rem;
    color: #26a;
    display: flex;
    flex-flow: row;
    margin: 0.3rem 0.4rem;
    padding: 0;
    white-space: nowrap;
  }
  .drawDate {
    font-size: 5vw;
  }
  select {
    font-size: 5vw;
    margin: 0 1vw;
  }
  .lotto {
    display: flex;
    align-items: center;
    overflow: auto;
    flex-flow: column;
    flex-direction: column-reverse;
  }
  .grid {
    flex: 1 0;
    overflow: auto;
    grid-template-columns: 1fr;
    align-self: stretch;
  }
  .winGrid {
    display: grid;
    grid-template-columns: 4fr 2fr 2fr 3fr;
    font-size: 3vw;
    gap: 1px;
    color: black;
    margin: 0;
  }
  .cell {
    padding: 1vw;
    text-align: right;
    white-space: nowrap;
    border: 1px solid silver;
  }
  .ball {
    height: 10vw;
    width: 10vw;
    line-height: 10vw;
    border-radius: 50%;
    margin: 0 0.5vw;
    font-size: 5vw;
    font-weight: bold;
  }
  .shadow {
    width: 10vw;
  }
  .print {
    display: none;
  }
}
@media print {
  .header,
  .lotto,
  .chart-container {
    display: none;
  }
  .container {
    margin-top: 0;
    margin-right: 1rem;
  }
  .ticketGroup {
    break-after: page; // modern alternative
    page-break-after: always;

    display: flex;
    flex-flow: column;
    justify-content: space-between;
    margin-top: 0.6cm;
  }
  .ticket {
    border: 1px solid silver;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0 0 2vw 0;
    position: relative;
  }
}
</style>